import { render, staticRenderFns } from "./SmsIndex.vue?vue&type=template&id=3c40f424&scoped=true&"
import script from "./SmsIndex.vue?vue&type=script&lang=js&"
export * from "./SmsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c40f424",
  null
  
)

export default component.exports